import { SelectBoxManager } from "./select-box-manager";
import { tryParseInt } from "./input-utils";

interface NotificationCreateEditConfiguration {
    ids: {
        recipientInput: string;
        levelInput: string;
        locationInput: string;
        deviceSection: string;
        deviceInput: string;
        sensorSection: string;
        sensorInput: string;
    };
    userId: string | undefined;
    locationId: number | undefined;
    deviceId: number | undefined;
    sensorId: number | undefined;
}

enum LevelOption {
    Location = "Location",
    Device = "Device",
    Sensor = "Sensor",
}

$(document).on("turbolinks:load", async function() {
    const configElement = document.getElementById("notification-create-edit-config");
    if (configElement) {
        const config: NotificationCreateEditConfiguration = JSON.parse(configElement.innerHTML);
        const page = new NotificationCreateEditPage(config);
        await page.initialise();
        $(document).one("turbolinks:before-render", () => page.destroy());
    }
});

export class NotificationCreateEditPage {
    private $recipientInput: JQuery;
    private $levelInput: JQuery;
    private $locationInput: JQuery;
    private $deviceSection: JQuery;
    private $deviceInput: JQuery;
    private $sensorSection: JQuery;
    private $sensorInput: JQuery;
    private selectBoxManager: SelectBoxManager = new SelectBoxManager();

    constructor(private config: NotificationCreateEditConfiguration) {
        this.$recipientInput = $("#" + config.ids.recipientInput);
        this.$levelInput = $("#" + config.ids.levelInput);
        this.$locationInput = $("#" + config.ids.locationInput);
        this.$deviceSection = $("#" + config.ids.deviceSection);
        this.$deviceInput = $("#" + config.ids.deviceInput);
        this.$sensorSection = $("#" + config.ids.sensorSection);
        this.$sensorInput = $("#" + config.ids.sensorInput);

        this.$recipientInput.on("change", this.onRecipientChange.bind(this));
        this.$levelInput.on("change", this.onLevelChange.bind(this));
        this.$locationInput.on("change", this.onLocationChange.bind(this));
        this.$deviceInput.on("change", this.onDeviceChange.bind(this));
    }

    public async initialise() {
        await this.selectBoxManager.initialise();
        this.onLevelChange();
        this.selectBoxManager.setOptions(this.$recipientInput, this.selectBoxManager.allUsers, this.config.userId, false);
        this.selectBoxManager.setOptions(this.$locationInput, this.selectBoxManager.getLocationsForUser(this.config.userId), this.config.locationId, false);
        this.selectBoxManager.setOptions(this.$deviceInput, this.selectBoxManager.getDevicesForLocation(this.config.locationId), this.config.deviceId, false)
        this.selectBoxManager.setOptions(this.$sensorInput, this.selectBoxManager.getSensorsForDevice(this.config.deviceId), this.config.sensorId, false);
    }

    public destroy() {
    }

    private onRecipientChange() {
        const userId = this.$recipientInput.val().toString();
        const options = !!userId ? this.selectBoxManager.getLocationsForUser(userId) : [];
        this.selectBoxManager.setOptions(this.$locationInput, options, null, false);
        this.onLocationChange();
    }

    private onLevelChange() {
        switch (this.$levelInput.val()) {
            case LevelOption.Location:
                this.$deviceSection.hide();
                this.$deviceInput.val("");
                this.$sensorSection.hide();
                this.$sensorInput.val("");
                break;
            case LevelOption.Device:
                this.$deviceSection.show();
                this.$sensorSection.hide();
                this.$sensorInput.val("");
                break;
            case LevelOption.Sensor:
                this.$deviceSection.show();
                this.$sensorSection.show();
                break;
        }
    }

    private onLocationChange() {
        const locationId = tryParseInt(this.$locationInput.val());
        const options = !!locationId ? this.selectBoxManager.getDevicesForLocation(locationId) : [];
        this.selectBoxManager.setOptions(this.$deviceInput, options, null, false);
        this.onDeviceChange();
    }

    private async onDeviceChange() {
        const deviceId = tryParseInt(this.$deviceInput.val());
        const options = !!deviceId ? this.selectBoxManager.getSensorsForDevice(deviceId) : [];
        this.selectBoxManager.setOptions(this.$sensorInput, options, null, false);
    }
}
